import styled from 'styled-components';

export const $TitleContainer = styled.div<{ $isFirst?: boolean }>`
  margin-top: ${({ $isFirst = false }) => ($isFirst ? 0 : '1rem')};

  margin-bottom: 1rem;
`;
